import React from 'react'
import { Tag } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { marcasApi } from '../../api/tabelasBasicas'

const MarcasPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Marcas de Produtos"
      breadcrumb="Tabelas › Básicas"
      icon={<Tag size={17} />}
      cdMaxLen={4}
      nmMaxLen={32}
      api={marcasApi}
    />
  )
}

export default MarcasPage
